import Admin from "../Admin";
import React from "react";
import CardAdminRegionList from "../../../Component/Card/Admin/Region/CardAdminRegionList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminRegionList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminRegionList />
        );
    }

    /**
     * Render the header.
     */
    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/region"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Regions" buttons={buttons} />
        );
    }
}
